import ModalLoading from './Loading.vue'
import { createApp } from 'vue';

const ModalLoad = {}
ModalLoad.install = function (Vue) {
  // 在全局状态下只有一个实例 options = {}option = {}
  let instance;
  let defaultOptions = {
    needBg: true // 默认需要背景
  }
  // 在Vue的原型上扩展方法
  Vue.config.globalProperties.$showLoading = function (option) {
    defaultOptions = Object.assign(defaultOptions, option)
    // 判断当前实例是不是已经存在
    if (!instance) {
      // 实例化插件并挂在到某一个元素上
      instance = createApp(ModalLoading).mount(
        document.createElement('div')
      );
      // 添加在body内
      document.body.appendChild(instance.$el)
      document.body.style.overflow = 'hidden'
    }
    if (instance.show) return
    instance.show = true
    instance.needBg = defaultOptions.needBg
  };
  Vue.config.globalProperties.$closeLoading = function () {
    instance ? (instance.show = false, document.body.style.overflow = 'auto') : ''
  }
}
export default ModalLoad